import { ValidationSchema } from "_core/form";
import { ErrorMessages } from "_core/types";

export type FormValues = {
  offStreetParking: string;
};

export const OffStreetParkingValidator: ValidationSchema<{
  offStreetParking: string;
}> = {
  offStreetParking: ({ offStreetParking }) => {
    if (!offStreetParking) return ErrorMessages.SELECT_REQUIRED;
  },
};
